import styled from 'styled-components';
import { TypographyStyles, media, spacing } from '@storefront/lib-global';

export const WidthContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXS};
  scroll-margin-top: 20px;

  @media ${media.greaterThan('lg')} {
    max-width: 523px;
    scroll-margin-top: ${spacing.XXXS};
  }
`;
export const WidthLabel = styled.span`
  ${TypographyStyles.Headings.H5}
  font-size: 14px;
  line-height: 24px;
  margin: 0;

  @media ${media.greaterThan('lg')} {
    font-size: 16px;
    line-height: 28px;
  }
`;
